var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-form-success"},[_c('div',{staticClass:"service-form-success-icon"},[_c('z-icon',{attrs:{"class-prefix":"zziconfont","name":"close-text"}})],1),_c('p',[_vm._v("该订单您已提交过，无法再次申请。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }